module.exports = __webpack_public_path__ + "media/images/sp/top/keyword_flower@3x-a0d9d2b09c3f779c9f38c7529023954b.webp";